var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory-run",attrs:{"id":"InventoryRun"}},[_c('inventory-run-component',{ref:"inventoryRunComponent",attrs:{"inventoryId":_vm.inventoryIdLocal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }